import { Container, Grid, Link } from "@mui/material";
import React from "react";
import SectionHeading from "../../Components/SectionHeading";

import logo from "../../images/new-logo.png"
import telegram from "../../images/telegram.png"
import medium from "../../images/medium.png"
import twitter from "../../images/twitter.png"
import instagram from "../../images/instagram.png"
import discord from "../../images/discord.png"
import gitbook from "../../images/gitbook.png"
import tiktok from "../../images/tiktok.png"

const Footer = () => {
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="pt-md-5"
                >
                    <Grid
                        xs={12}
                        sm={6}
                        className="text-center text-sm-left"
                    >
                        <img src={logo} className="img-fluid" style={{maxWidth:150}} />
                    </Grid>
                    <Grid
                        xs={12}
                        sm={6}
                        className="text-center text-sm-right align-self-center mt-4 mt-sm-0"
                    >
                        <div className="MS---socialMedia"> 
                            <Link href="https://t.me/MetaSnooker" className="d-inline-block mr-3" target="_blank">
                                <img src={telegram} className="img-fluid" />
                            </Link>
                            <Link href="https://metasnooker.medium.com" className="d-inline-block mr-3" target="_blank">
                                <img src={medium} className="img-fluid" />
                            </Link>
                            <Link href="https://twitter.com/Snooker_Meta" className="d-inline-block mr-3" target="_blank">
                                <img src={twitter} className="img-fluid" />
                            </Link>
                            <Link href="https://www.instagram.com/meta.snooker" className="d-inline-block mr-3" target="_blank">
                                <img src={instagram} className="img-fluid" />
                            </Link>
                            {/* <Link href="https://discord.com/invite/8dPAQC3s" className="d-inline-block mb-3" target="_blank">
                                <img src={discord} className="img-fluid" />
                            </Link> */}
                            <Link href="https://docs.metasnooker.io/tokenomics" className="d-inline-block mr-3" target="_blank">
                                <img src={gitbook} className="img-fluid" />
                            </Link>
                            <Link href="http://tiktok.com/@metasnooker" className="d-inline-block" target="_blank">
                                <img src={tiktok} className="img-fluid" />
                            </Link>
                        </div> 
                    </Grid>
                </Grid>
                <div style={{border: '1px solid #ffffff20', margin: '20px 0'}} />
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                >
                    <Grid
                        xs={12}
                        sm={6}
                        className="text-center text-sm-left"
                    >
                        <p>
                            Metasnooker © 2022. All Rights Reserved.
                        </p>
                    </Grid>
                    <Grid
                        xs={12}
                        sm={6}
                        className="text-center text-sm-right mt-2 "
                    >
                        <Link href="/terms" className="d-inline-block" target="_blank">
                            Terms & Conditions
                        </Link>
                        &nbsp;&nbsp;&nbsp;
                        <Link href="/privacy-policy" className="d-inline-block" target="_blank">
                            Privacy Policy
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Footer;